// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
import run from "../../../utilities/run";
require("../../stubs/hcuGlossary/hcuGlossary.less");

const glossaryOuterSelector = "#p_p_id_navigationportlet_WAR_commerceuportlet_";

run(glossaryOuterSelector, ()=>{
	attachGlossary();
});

function attachGlossary(){
	
}


// WEBPACK FOOTER //
// ./src/pages/hcu/hcuGlossary/hcuGlossary.js